import { Injectable } from '@angular/core';
import { DataProviderService } from './data-provider.service';
import { Observable } from 'rxjs';
import { IDataSource } from './IDataSource';

@Injectable()
export class LangDataService {
    private labelTable: { [key: string]: string } = null;

    public get hasDataAvailable(): boolean {
        return this.labelTable !== null;
    }

    constructor(private dataProvider: DataProviderService) {}

    public loadData(complete: () => void) {
        if (this.hasDataAvailable) {
            complete();
            return;
        }

        this.dataProvider.getData(false).subscribe(
            (essentialData: IDataSource) => {
                this.labelTable = essentialData.labels;
                complete();
            },
            console.error);
    }

    /**
     * Returns the translation string for the given key.
     * Do not call this method if "hasDataAvailable" returns false.
     *
     * @param defaultString the string returned if no translated value for key exists.
     */
    public getString(key: string, defaultString?: string): string {
        if (!this.hasDataAvailable)
            throw new Error("Translation data have not been loaded yet.");

        let result = this.labelTable[key];
        if (result === undefined) {
            console.warn(`No translation found for key "${key}".`);

            if (defaultString !== undefined)
                result = defaultString;
            else
                result = `{trans-id-missing: ${key}}`;
        }

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/lang-data.service.ts